import React, { useState } from 'react';
import { Button } from 'devextreme-react/button';
import Popover from 'devextreme-react/popover';
import { RiskMeterFinancialDto } from '../../../../dtos/RiskMeterFinancialDto';
import { getBufferOverallColor, NOT_STARTED_COLOR } from '../utils/riskMeterColors';
import { formatCurrency } from '../utils/currency';
import FinancialSliceTooltip from './FinancialSliceTooltip';
import './RiskMeter.css';

interface RiskMeterFinancialTableProps {
    financial: RiskMeterFinancialDto;
    canEdit?: boolean;
    onEdit?: () => void;
}

export default function RiskMeterFinancialTable({ financial, canEdit, onEdit }: RiskMeterFinancialTableProps) {
    const [isHovered, setIsHovered] = useState(false);

    const numberColumnStyle = { width: '160px', textAlign: 'center' as const };
    const cellStyle = { textAlign: 'center' as const };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <h5 style={{ margin: 0 }}>Financial</h5>
                {canEdit && onEdit && (
                    <Button
                        className="ganttLabelButton"
                        height={25}
                        icon="edit"
                        hint="Edit financial data"
                        text="Edit"
                        type="normal"
                        stylingMode="contained"
                        onClick={onEdit}
                    />
                )}
            </div>

            <table className="table table-bordered table-sm risk-meter-table">
                <thead>
                    <tr>
                        <th style={numberColumnStyle}>Available Funds</th>
                        <th style={numberColumnStyle}>Project Required Budget</th>
                        <th style={numberColumnStyle}>Ratio</th>
                        <th style={numberColumnStyle}>Score</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        id="risk-financial-row"
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <td style={cellStyle}>{formatCurrency(financial.availableFunds)}</td>
                        <td style={cellStyle}>{formatCurrency(financial.projectRequiredBudget)}</td>
                        <td style={cellStyle}>{financial.ratio !== null ? financial.ratio.toFixed(2) : '-'}</td>
                        <td style={{
                            ...cellStyle,
                            backgroundColor: financial.score !== null ? getBufferOverallColor(financial.score) : NOT_STARTED_COLOR,
                            fontWeight: 'bold'
                        }}>
                            {financial.score !== null ? financial.score : '-'}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Anchored below rather than to the right: this table spans the full width, so a popover
                to its right gets squeezed against the edge of the viewport. */}
            <Popover target="#risk-financial-row" visible={isHovered} position="bottom" width={480}>
                <FinancialSliceTooltip financial={financial} score={financial.score} />
            </Popover>
        </>
    );
}
